type ShareDeltaSignOptions = { spaced?: boolean };

/**
 * The sign of a pool size change: "+", or a minus for a decrease. `spaced` is for the Adjust Pool
 * Size modal, which sets the sign apart from its counting number and uses a hyphen; the Events
 * ledger badge uses a typographic minus.
 */
export const getShareDeltaSign = (delta: number, { spaced = false }: ShareDeltaSignOptions = {}) =>
  delta < 0 ? (spaced ? '-' : '−') : '+';

/** Signed share change for the Events ledger badge: "+10,000" / "−5,000", sign and number joined. */
export const formatShareDelta = (delta: number) =>
  `${getShareDeltaSign(delta)}${Math.abs(delta).toLocaleString('en-US')}`;
